import * as yup from 'yup';

function serviceSiteName(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'SERVICE_SITE_NAME_IS_REQUIRED',
        defaultMessage: 'Service Site Name is required',
      }),
    )
    .max(
      64,
      formatMessage({
        id: 'CREATEFORM_SERVICESITENAME_FIELD_MAX_CHARS_64',
        defaultMessage: 'Service Site Name should be less than 64 chars',
      }),
    );
}

function serviceSiteCode(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'SERVICE_SITE_CODE_IS_REQUIRED',
        defaultMessage: 'Service Site Code is required',
      }),
    )
    .max(
      64,
      formatMessage({
        id: 'CREATEFORM_SERVICESITECODE_FIELD_MAX_CHARS_64',
        defaultMessage: 'Service Site Code should be less than 64 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'STATUS_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      serviceSiteName: serviceSiteName(formatMessage),
      serviceSiteCode: serviceSiteCode(formatMessage),
      status: status(formatMessage),
    })
    .required();

export default validationSchema;
